module.exports = __webpack_public_path__ + "451cc9f6c3cb429201dc44ac32bc8a3e.png";